<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1"><span style="color: #2AD3DA">{{ data1['price'] + '万吨' }}</span></div>
        <div class="data2"><span style="color: #2AD3DA">{{ data2['price'] }}</span></div>
        <div class="data3"><span style="color: #2AD3DA">{{ data3['price'] }}</span></div>
        <div class="data4"><span style="color: #2AD3DA">{{ data4['price'] }}</span>
        </div>
        <div class="data5"><span style="color: #2AD3DA">{{ data5['price'] }}</span>
        </div>
        <div class="data6"><span style="color: #2AD3DA">{{ data6['price'] }}</span>
        </div>
        <div class="data7"><span style="color: #2AD3DA">{{ data7['price'] }}</span>
        </div>
        <div class="data8"><span style="color: #2AD3DA">{{ data8['price'] }}</span>
        </div>
        <div class="data9"><span style="color: #2AD3DA">{{ data9['price'] }}</span>
        </div>
        <div class="data10"><span style="color: #2AD3DA">{{ data10['price'] }}</span>
        </div>
        <div class="data11"><span style="color: #2AD3DA">{{ data11['price'] }}</span>
        </div>
        <div class="data12"><span style="color: #2AD3DA">{{ data12['price'] }}</span>
        </div>
        <div class="data13"><span style="color: #2AD3DA">{{ data13['price'] }}</span>
        </div>
        <div class="data14"><span style="color: #2AD3DA">{{ data14['price'] }}</span>
        </div>
        <div class="differPrice1 redColor" v-if="chainPrice['differPrice1'] > 0">
          {{ '+' + chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1 greenColor" v-if="chainPrice['differPrice1'] < 0">{{ chainPrice['differPrice1'] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">—</div>
        <div class="differPrice2 redColor" v-if="chainPrice['differPrice2'] > 0">
          {{ '+' + chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2 greenColor" v-if="chainPrice['differPrice2'] < 0">{{ chainPrice['differPrice2'] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">—</div>
        <div class="differPrice3 redColor" v-if="chainPrice['differPrice3'] > 0">
          {{ '+' + chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3 greenColor" v-if="chainPrice['differPrice3'] < 0">{{ chainPrice['differPrice3'] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">—</div>
        <div class="differPrice4 redColor" v-if="chainPrice['differPrice4'] > 0">
          {{ '+' + chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4 greenColor" v-if="chainPrice['differPrice4'] < 0">{{ chainPrice['differPrice4'] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">—</div>
        <div class="differPrice5 redColor" v-if="chainPrice['differPrice5'] > 0">
          {{ '+' + chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5 greenColor" v-if="chainPrice['differPrice5'] < 0">{{ chainPrice['differPrice5'] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">—</div>
        <div class="differPrice6 redColor" v-if="chainPrice['differPrice6'] > 0">
          {{ '+' + chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6 greenColor" v-if="chainPrice['differPrice6'] < 0">{{ chainPrice['differPrice6'] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">—</div>
        <div class="differPrice7 redColor" v-if="chainPrice['differPrice7'] > 0">
          {{ '+' + chainPrice['differPrice7'] }}
        </div>
        <div class="differPrice7 greenColor" v-if="chainPrice['differPrice7'] < 0">{{ chainPrice['differPrice7'] }}
        </div>
        <div class="differPrice7" v-if="chainPrice['differPrice7'] === 0">—</div>
        <div class="differPrice8 redColor" v-if="chainPrice['differPrice8'] > 0">
          {{ '+' + chainPrice['differPrice8'] }}
        </div>
        <div class="differPrice8 greenColor" v-if="chainPrice['differPrice8'] < 0">{{ chainPrice['differPrice8'] }}
        </div>
        <div class="differPrice8" v-if="chainPrice['differPrice8'] === 0">—</div>
        <div class="differPrice9 redColor" v-if="chainPrice['differPrice9'] > 0">
          {{ '+' + chainPrice['differPrice9'] }}
        </div>
        <div class="differPrice9 greenColor" v-if="chainPrice['differPrice9'] < 0">{{ chainPrice['differPrice9'] }}
        </div>
        <div class="differPrice9" v-if="chainPrice['differPrice9'] === 0">—</div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write title-write-red">招投标
          </div>
          <span class="title-more fr" @click="toTwoPage('/cokeBenzene/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryListOne" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/cokeBenzene/industry', item.id)">{{
                  item.titleName
                }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position: relative">
          <div class="head">
            <i></i>
            <em></em>
            <p>石油苯中石化挂牌价</p>
            <div class="unit">｜ 元/吨</div>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content" @click="changeLine" style="cursor:pointer">
            <div id="myChart" style="width: 372px;height:290px;cursor:pointer"></div>
          </div>
        </li>
        <li style="position:relative;">
          <img style="margin-bottom: -7px;" src="../../assets/ironstone/jiage.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #222222;line-height: 33px;">
            价格</p>
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer"
                @click="toTwoPage('/cokeBenzene/twoPage/price', 1)"> >></span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 1"
                style='font-size: 12px;'
                @click="toTwoPage('/cokeBenzene/twoPage/price', 1)"
                :class="{'priceFlag':priceFlag === 1}">中石化挂牌价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 28"
                style='font-size: 12px;'
                @click="toTwoPage('/cokeBenzene/twoPage/price', 28)"
                :class="{'priceFlag':priceFlag === 28}">主流市场价格行情</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 29"
                style='font-size: 12px;'
                @click="toTwoPage('/cokeBenzene/twoPage/price', 29)"
                :class="{'priceFlag':priceFlag === 29}">加氢苯价格动态</span>
          <div class="classification-content" v-if="priceFlag === 1">
            <div class="classification-content-div price" v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/cokeBenzene/price', item.completeOriginalDate, 1)">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.date + '中石化石油苯挂牌价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 28">
            <div class="classification-content-div price" v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/cokeBenzene/backPrice', item.id, 28)">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="priceFlag === 29">
            <div class="classification-content-div price" v-for="(item, index) in priceThreeList" :key="index"
                 @click="goDetail('/cokeBenzene/backPrice', item.id, 29)">
              <img src="../../assets/home/jiage.jpg" alt="">
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/cokeBenzene/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/cokeBenzene/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/cokeBenzene/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/cokeBenzene/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/home/chanliang.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #fff;line-height: 33px;">
            产量</p>
          <img src="../../assets/home/neibu.png" style="position: absolute;left: 83px;width: 70px;top: 24px;" alt="">
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer;color:#fff"
                @click="toTwoPage('/cokeBenzene/twoPage/yield')"> >></span>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in yieldList" :key="index"
                 @click="goDetail('/cokeBenzene/yield', item.completeOriginalDate, 'manual_entry_styrene_coke_yield')">
              <i></i>
              <p>{{ item.date + '焦化苯产量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head">
            <i></i>
            <em></em>
            <p>开工率</p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content" @click="changeRateLine" style="cursor:pointer">
            <div id="myChartRate" style="width: 372px;height:250px;cursor:pointer"></div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none;">
            <em></em>
            <p>企业分布 <b style="color: #D3131A;font-size: 18px;margin-left: -5px;font-weight: normal">地图</b></p>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
          </div>
          <div class="classification-content">
            <img style="cursor: pointer" src="../../assets/home/map.png" @click="goDetail('/cokeBenzene/map')" alt="">
<!--            <Expect :marginTop="'40px'"></Expect>-->
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'库存'" :flag="false" :unit="false"
                                :url="'/cokeBenzene/twoPage/stock'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in stockList" :key="index"
                 @click="goDetail('/cokeBenzene/stock', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'装置动态'" :flag="false" :unit="false"
                                :url="'/cokeBenzene/twoPage/device'"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in industryListFour" :key="index"
                 @click="goDetail('/cokeBenzene/device', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
<!--        <li>-->
<!--          <img src="../../assets/methanol/dashuju.png" alt="">-->
<!--          <div class="classification-content">-->
<!--            <Expect></Expect>-->
<!--          </div>-->
<!--        </li>-->
        <li>
          <ClassificationHeader :name="'进出口'" :flag="false" :unit="false"
                                :params="{title:'进出口',typeList:['按产销国统计', '数据统计']}"
                                :url="'/cokeBenzene/twoPage/exit'"></ClassificationHeader>
          <span class="classification-tabs-three" style="width:186px;" @mouseover="exitFlag = 1"
                @click="toTwoPage('/cokeBenzene/twoPage/exit', 19)"
                :class="{'stockFlag':exitFlag === 1}">按产销国统计</span>
          <span class="classification-tabs-three" style="width:186px;" @mouseover="exitFlag = 2"
                @click="toTwoPage('/cokeBenzene/twoPage/exit', 20)"
                :class="{'stockFlag':exitFlag === 2}">数据统计</span>
          <div class="classification-content" style="margin-top: 4px" v-if="exitFlag === 1">
            <div class="classification-content-div" v-for="(item, index) in exitOneList" :key="index"
                 @click="goDetail('/cokeBenzene/exit', item.id, 19)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="exitFlag === 2">
            <div class="classification-content-div" v-for="(item, index) in exitTwoList" :key="index"
                 @click="goDetail('/cokeBenzene/exit', item.id, 20)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'相关产品价格'" :flag="true" :unit="false"
                                :params="{title:'相关产品价格',typeList:['苯乙烯', '其他']}"
                                :url="'/cokeBenzene/twoPage/productPrice'"></ClassificationHeader>
          <span class="classification-tabs-three" style="width:186px;" @mouseover="productPriceFlag = 1"
                @click="toTwoPage('/cokeBenzene/twoPage/productPrice', 1)"
                :class="{'stockFlag':productPriceFlag === 1}">苯乙烯</span>
          <span class="classification-tabs-three" style="width:186px;" @mouseover="productPriceFlag = 2"
                @click="toTwoPage('/cokeBenzene/twoPage/productPrice', 2)"
                :class="{'stockFlag':productPriceFlag === 2}">其他</span>
          <div class="classification-content" style="margin-top: 4px" v-if="productPriceFlag === 1">
            <div class="classification-content-div" v-for="(item, index) in productPriceListOne" :key="index"
                 @click="goDetail('/cokeBenzene/productPriceContent', item.id)">
              <i></i>
              <p>{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px" v-if="productPriceFlag === 2">
            <div class="classification-content-div" v-for="(item, index) in productPriceList" :key="index"
                 @click="goDetail('/cokeBenzene/productPrice', item.completeOriginalDate)">
              <i></i>
              <p>{{ item.date + '相关产品价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li style="position:relative;">
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/cokeBenzene/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="exitClass">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="lineFlag">
      <BigLine :childData="childData" @closeIndustrialCh="closeLine"></BigLine>
    </el-dialog>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="lineRateFlag">
      <BigLineRate :childDataRate="childRateData" @closeIndustrialCh="closeRateLine"></BigLineRate>
    </el-dialog>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="980px"
               :visible.sync="industrialFlag">
      <OilBenzeneIndustrial :chainPrice="chainPrice" :chainTitle="chainTitle" :data1="data1" :data2="data2"
                            :data3="data3"
                            :data4="data4" :data5="data5" :data6="data6" :data7="data7" :data8="data8" :data9="data9"
                            :data10="data10" :data11="data11" :data12="data12" :data13="data13" :data14="data14"
                            @closeIndustrialCh="closeIndustrial"></OilBenzeneIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  industryDetail,
  reportNoAuthList,
  reportDetail,
  standardDetail,
  yieldNoAuthList,
  productPricedNoAuthList,
  priceLineData,
  rateLineData,
  priceNoAuthList,
  chainList, priceLineDataBig, rateLineDataBig, getAuthFlag
} from '@/api/cokeBenzene'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import BigLine from '@/components/bigLine/bigLine'
import BigLineRate from "@/components/bigLine/bigLineRate";
import OilBenzeneIndustrial from '@/components/bigChart/oilBenzeneIndustrial'

export default {
  name: "index",
  components: {
    BigLineRate,
    ClassificationHeader,
    Expect,
    OilBenzeneIndustrial,
    BigLine
  },
  data() {
    return {
      // 行业动态
      industryListOne: [],
      // 装置动态
      industryListFour:[],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 1,
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      // 库存
      stockList: [],
      // 开工率
      rateList: [],
      // 进出口量
      exitFlag: 1,
      exitOneList: [],
      exitTwoList: [],
      // 新增淘汰产能
      boardList: [],
      // 产量
      yieldList: [],
      // 行业标准
      standardList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      data9: {},
      data10: {},
      data11: {},
      data12: {},
      data13: {},
      data14: {},
      chainPrice: {},
      // 重点企业资讯
      enterpriseList: [],
      industrialFlag: false,
      // 相关产品价格
      productPriceFlag: 1,
      productPriceListOne: [],
      productPriceList: [],
      // 价格折线图
      option: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
          {
            name: "价格",
            type: "line",
            data: [5, 20, 36, 10, 10, 20]
          }
        ],
        grid: {
          x: 40,
          y: 25,
          x2: 10,
          y2: 50
        },
      },
      optionRate: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ["开工率"]
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
        },
        yAxis: {},
        series: [
          {
            name: "开工率",
            type: "line",
            data: [5, 20, 36, 10, 10, 20]
          }
        ],
        grid: {
          x: 40,
          y: 25,
          x2: 10,
          y2: 50
        },
      },
      // 折线图大图
      lineFlag: false,
      childData: {},
      lineRateFlag: false,
      childRateData: {},
      datuFLag: 'price',
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // // 产业链
      chainList({dictDataType: 'issue_petroleum_benzene_chain'}).then(res => {
        this.chainTitle = res.data['titleTime'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
        this.data5 = res.data['data5'];
        this.data6 = res.data['data6'];
        this.data7 = res.data['data7'];
        this.data8 = res.data['data8'];
        this.data9 = res.data['data9'];
        this.data10 = res.data['data10'];
        this.data11 = res.data['data11'];
        this.data12 = res.data['data12'];
        this.data13 = res.data['data13'];
        this.data14 = res.data['data14'];
        this.chainPrice = res.data['price'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 24}).then(res => {
        this.industryListOne = res.rows;
      })
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 25}).then(res => {
        this.industryListFour = res.rows;
      })
      // 研究报告
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 9, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 技术及标准
      reportNoAuthList({pageNum: 1, pageSize: 7, sourceType: 9, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
      // 相关产品价格
      productPricedNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: 'issue_petroleum_benzene_relevant_price',
        dataType: 1
      }).then(res => {
        this.productPriceList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 21,
      }).then(res => {
        this.productPriceListOne = res.rows;
      })
      // 价格指数
      priceNoAuthList({pageNum: 1, pageSize: 6, dictDataType:'manual_entry_styrene_price'}).then(res => {
        this.priceOneList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 28,
      }).then(res => {
        this.priceTwoList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 29,
      }).then(res => {
        this.priceThreeList = res.rows;
      })
      // 库存
      industryNoAuthList({
        pageNum: 1,
        pageSize: 8,
        sourceType: 22,
      }).then(res => {
        this.stockList = res.rows;
      })
      // 产量
      priceNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'manual_entry_styrene_coke_yield'}).then(res => {
        this.yieldList = res.rows;
      })
      // 价格折线图
      priceLineData({dictDataType:'manual_entry_styrene_price'}).then(res => {
        this.option.series[0].data = res.data.dateList;
        this.option.xAxis.data = res.data.timeList;
        // this.option.series[0].name = res.data.yearList[0];
        this.drawChart();
      })
      // 开工率折线图
      priceLineData({dictDataType:'manual_entry_styrene_rate'}).then(res => {
        this.optionRate.series[0].data = res.data.dateList;
        // this.optionRate.series[0].name = res.data.yearList[0];
        this.optionRate.xAxis.data = res.data.timeList;
        this.drawChart();
      })
      // 进出口量
      industryNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 19,
      }).then(res => {
        this.exitOneList = res.rows;
      })
      industryNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 20,
      }).then(res => {
        this.exitTwoList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭折线图模态
     */
    changeLine() {
      priceLineDataBig({enlargeFlag: true}).then(res => {
        this.lineFlag = true;
        this.childData = res.data;
      })
    },
    changeRateLine() {
      rateLineDataBig({enlargeFlag: true}).then(res => {
        this.childRateData = res.data;
        this.lineRateFlag = true;
      })
    },
    closeLine() {
      this.lineFlag = false;
    },
    closeRateLine() {
      this.lineRateFlag = false;
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['焦化苯', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['焦化苯', '技术及标准', '正文'], row['id']);
      })
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let myChartRate = this.$echarts.init(document.getElementById("myChartRate"));
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option);
      myChartRate.setOption(this.optionRate);
    },
    /**
     * 切换tabs
     */
    changeFlag(flag) {
      this.industryFlag = flag;
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag) {
      this.$router.push({path: `${url}`, query: {id, flag}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/home/shiyoubenBaner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #CEEFF6;
      top: 22px;
      left: 387px;
    }

    .data1 {
      font-size: 14px;
      position: absolute;
      top: 149px;
      left: 144px;
      width: 97px;
      height: 50px;
      text-align: center;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 202px;
      left: 140px;
      text-align: center;
      width: 106px;
      height: 50px;
    }

    .data3 {
      font-size: 10px;
      position: absolute;
      top: 246px;
      left: 139px;
      width: 106px;
      text-align: center;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 286px;
      left: 139px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 128px;
      left: 275px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 205px;
      left: 273px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 245px;
      left: 273px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 281px;
      left: 273px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data9 {
      font-size: 10px;
      position: absolute;
      top: 311px;
      left: 273px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data10 {
      font-size: 10px;
      position: absolute;
      top: 91px;
      left: 407px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data11 {
      font-size: 10px;
      position: absolute;
      top: 133px;
      left: 407px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data12 {
      font-size: 10px;
      position: absolute;
      top: 168px;
      left: 407px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data13 {
      font-size: 10px;
      position: absolute;
      top: 203px;
      left: 407px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .data14 {
      font-size: 10px;
      position: absolute;
      top: 243px;
      left: 407px;
      width: 106px;
      height: 50px;
      text-align: center;
    }

    .differPrice1 {
      position: absolute;
      top: 101px;
      left: 242px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      position: absolute;
      top: 179px;
      left: 242px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      position: absolute;
      top: 220px;
      left: 242px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      position: absolute;
      top: 252px;
      left: 242px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      position: absolute;
      top: 73px;
      left: 376px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      position: absolute;
      top: 106px;
      left: 376px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice7 {
      position: absolute;
      top: 138px;
      left: 376px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice8 {
      position: absolute;
      top: 177px;
      left: 376px;
      width: 25px;
      height: 25px;
      text-align: center;
    }

    .differPrice9 {
      position: absolute;
      top: 213px;
      left: 376px;
      width: 25px;
      height: 25px;
      text-align: center;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 124px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}

.head {
  color: #222222;
  height: 35px;
  line-height: 30px;
  position: relative;
  border-bottom: 2px solid #ccc;

  i {
    width: 60px;
    height: 2px;
    background: #CCCCCC;
    display: inline-block;
    position: absolute;
    bottom: 0;
  }

  em {
    width: 4px;
    height: 18px;
    background: #D3131A;
    font-style: normal;
    display: inline-block;
    margin-right: 9px;
    vertical-align: middle;
  }

  p {
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
  }

  .unit {
    color: #999999;
    margin-left: 10px;
    display: inline-block;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    cursor: pointer;
    height: 20px;
    border-bottom: 1px solid #fff;
  }

  span:hover {
    border-bottom: 1px solid #222;
  }
}
</style>
